import * as React from 'react';
import { ArticleHeading3, Image } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IPikPlusFeatureCardProps {
  title: string;
  imageUrl: string;
}

export function PikPlusFeatureCard({ title, imageUrl }: IPikPlusFeatureCardProps) {
  return (
    <div className={styles['container']} data-testid="pik_plus_feature_card">
      <Image
        alt="image"
        borderRadius="4px"
        display="inline-block"
        height={320}
        objectFit="cover"
        preloader
        src={imageUrl}
        theme="dark"
        width={263}
      />
      <div className={styles['title']}>
        <ArticleHeading3 color="white_100">{title}</ArticleHeading3>
      </div>
    </div>
  );
}
